const Config = {
  // api_url: 'http://localhost:8080/startpecifi/starpecificapi',
   api_url: 'https://dev.starpacific.ramatechno.com/demo',
   app_url: 'https://dev.starpacific.ramatechno.com'

  //  api_url: 'https://starpacific.ramatechno.com/demo',
  //  app_url: 'https://starpacific.ramatechno.com'
  // api_url: "http://localhost:8080/startpecifi/starpecificapi",
   //app_url: "http://localhost:3000",
};

export default Config;
